import React from "react";
import { Route, Redirect, useHistory } from "react-router-dom";
import jwt_decode from "jwt-decode";

const auth = localStorage.getItem("accessToken");

const PrivateRoute = ({ exact, component: Component, ...rest }) => {


  const history = useHistory();

  const userLoginDetails =  JSON.parse(localStorage.getItem("userInitDetails"));

  console.log(userLoginDetails)

  if (auth) {
    const jwt_Token_decoded = jwt_decode(localStorage.getItem("accessToken"));
    console.log(jwt_Token_decoded.exp * 1000);
    console.log(Date.now());
    if (jwt_Token_decoded.exp * 1000 < Date.now()) {
      history.push("/auth-login");
    }
  }

//   return (
//     <Route
//       exact={exact ? true : false}
//       rest
//       render={(props) =>
//         auth ? (
//           <Component {...props} {...rest}></Component>
//         ) : (
//           <Redirect to={`${process.env.PUBLIC_URL}/homepage`}></Redirect>
//           // <Redirect to={`${process.env.PUBLIC_URL}/auth-login`}></Redirect>
//         )
//       }
//     ></Route>
//   )
// };


return (
  <Route
    exact={exact ? true : false}
    rest
    render={(props) =>
      auth ? (<>
        {(userLoginDetails.profile_approval_status == "NOT_INITIATED" || userLoginDetails.profile_approval_status == "REJECTED") ? <Redirect to={`${process.env.PUBLIC_URL}/steps-designer-profile`}></Redirect> :
          <Component {...props} {...rest}></Component>
        }          
        </>) : (
        <Redirect to={`${process.env.PUBLIC_URL}/homepage`}></Redirect>
        // <Redirect to={`${process.env.PUBLIC_URL}/auth-login`}></Redirect>
      )
    }
  ></Route>
)
};

export default PrivateRoute;
